export default __webpack_public_path__ + "static/media/Reina-Natasha-Entheogens-Lyrics.c98f9fe6.mp4";